
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

import { ApiCallGet } from '../ApiCall/ApiCall';



export default function Saldos() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));
        ApiCallGet( "saldos" )
        .then((response) => {

            for( var i = 0 ; i < response.length ; i++ )
            {
                response[i].mRecarga = "$" + response[i].mRecarga + ".00"
                response[i].promocionSaldo = "$" + response[i].promocionSaldo + ".00"
            }


            setProducts( response )



        })
        .catch((err) =>{
            console.log( err )
        })
    }, []);

    return (
        <div className=''>

            <div className='flex justify-content-center'>
                <h3>
                    Saldos
                </h3>
            </div>



            <div className='flex justify-content-center' >
        
                <div className="card " style={{width:'70%',backgroundColor:'black', borderRadius :'10px' , color:'black'}}>
                    <DataTable value={products} stripedRows  
                        tableStyle={{ minWidth: '50rem' ,backgroundColor:'black', borderRadius :'10px' , color:'black'}}>
                        <Column field="id" header="id"></Column>
                        <Column field="mRecarga" header="Recarga"></Column>
                        <Column field="promocionSaldo" header="Promo Saldo"></Column>
                        <Column field="nDias" header="Dias"></Column>
                    </DataTable>
                </div>

            </div>
        </div>
    );
}
        